export const APP_GALLERY = {
  "Gallery.Space.Around": {
    defaultValue: "default"
  },
  "Gallery.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Gallery.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Gallery.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Gallery.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Gallery.Height.Type": {
    defaultValue: "fixed"
  },

  "Gallery.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Border.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Gallery.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Gallery.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Gallery.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Gallery.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Padding.Top": {
    defaultValue: "0px"
  },
  "Gallery.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Gallery.Padding.Left": {
    defaultValue: "0px"
  },
  "Gallery.Padding.Right": {
    defaultValue: "0px"
  },
  "Gallery.Shadow": {
    defaultValue: "none"
  },
  "Gallery.Shadow.Type": {
    defaultValue: "none"
  },
  "Gallery.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Gallery.Row.Gap": {
    ref: "Space.16"
  },
  "Gallery.Column.Gap": {
    ref: "Space.16"
  },
  "Gallery.Header.Color": {
    ref: "Color.Gray.400"
  },
  "Gallery.Header.Font.Size": {
    ref: "Font.Size.16"
  },
  "Gallery.Header.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Gallery.Header.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Header.Padding.Top": {
    defaultValue: "0px"
  },
  "Gallery.Header.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Gallery.Header.Padding.Left": {
    defaultValue: "0px"
  },
  "Gallery.Header.Padding.Right": {
    defaultValue: "0px"
  },
  "Gallery.Card.Bg.Color": {
    ref: "Color.White"
  },
  "Gallery.Card.Border.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Card.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Padding.Top": {
    ref: "Space.12"
  },
  "Gallery.Card.Padding.Bottom": {
    ref: "Space.12"
  },
  "Gallery.Card.Padding.Left": {
    ref: "Space.12"
  },
  "Gallery.Card.Padding.Right": {
    ref: "Space.12"
  },
  "Gallery.Card.Shadow.Type": {
    ref: "Shadow.100.Pos"
  },
  "Gallery.Card.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Gallery.Card.Hover.Bg.Color": {
    ref: "Color.White"
  },
  "Gallery.Card.Hover.Shadow.Type": {
    ref: "Shadow.200.Pos"
  },
  "Gallery.Card.Hover.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Gallery.Card.Hover.Border.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Card.Hover.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Hover.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Hover.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Hover.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Button.Color": {
    ref: "Button.Primary.Color"
  },
  "Gallery.Card.Button.Bg.Color": {
    ref: "Button.Primary.Bg.Color"
  },
  "Gallery.Card.Button.Padding.Top": {
    defaultValue: "4px"
  },
  "Gallery.Card.Button.Padding.Bottom": {
    defaultValue: "4px"
  },
  "Gallery.Card.Button.Padding.Left": {
    defaultValue: "4px"
  },
  "Gallery.Card.Button.Padding.Right": {
    defaultValue: "4px"
  },
  "Gallery.Card.Image.Object.Fit": {
    defaultValue: "fill"
  },
  "Gallery.Card.Image.Border.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Card.Image.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Image.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Image.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Image.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Gallery.Card.Image.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Image.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Image.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Image.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Gallery.Card.Title.Color": {
    ref: "Color.Gray.500"
  },
  "Gallery.Card.Title.Font.Size": {
    ref: "Font.Size.16"
  },
  "Gallery.Card.Title.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Gallery.Card.Title.Caption.Font.Size": {
    ref: "Font.Size.12"
  },
  "Gallery.Card.Title.Caption.Color": {
    ref: "Color.Gray.200"
  },
  "Gallery.Card.Title.Caption.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Gallery.Card.Subtitle.Font.Size": {
    ref: "Font.Size.14"
  },
  "Gallery.Card.Subtitle.Color": {
    ref: "Color.Gray.500"
  },
  "Gallery.Card.Subtitle.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Gallery.Card.Subtitle.Caption.Font.Size": {
    ref: "Font.Size.11"
  },
  "Gallery.Card.Subtitle.Caption.Color": {
    ref: "Color.Gray.100"
  },
  "Gallery.Card.Subtitle.Caption.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Gallery.Card.Bodytext.Font.Size": {
    ref: "Font.Size.11"
  },
  "Gallery.Card.Bodytext.Color": {
    ref: "Color.Gray.100"
  },
  "Gallery.Card.Bodytext.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Gallery.Width": {
    defaultValue: "100%"
  },
  "Gallery.Height": {
    defaultValue: "500px"
  },
  "Gallery.Min.Width": {
    defaultValue: "0px"
  },
  "Gallery.Max.Width": {
    defaultValue: "none"
  },
  "Gallery.Min.Height": {
    defaultValue: "0px"
  },
  "Gallery.Max.Height": {
    defaultValue: "none"
  },
  "Gallery.Overflow": {
    defaultValue: "auto"
  },
  "Gallery.Background.Color": {
    ref: "Color.Transparent"
  },
  "Gallery.Box.Shadow": {
    defaultValue: "none"
  },
  "Gallery.Border.Style": {
    defaultValue: "solid"
  },
  "Gallery.Border.Left": {
    defaultValue: "0px"
  },
  "Gallery.Border.Right": {
    defaultValue: "0px"
  },
  "Gallery.Border.Top": {
    defaultValue: "0px"
  },
  "Gallery.Border.Bottom": {
    defaultValue: "0px"
  },
  "Gallery.Border.Start.Start.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Border.Start.End.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Border.End.Start.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Border.End.End.Radius": {
    defaultValue: "0px"
  },
  "Gallery.Margin.Left": {
    defaultValue: "0px"
  },
  "Gallery.Margin.Right": {
    defaultValue: "0px"
  },
  "Gallery.Margin.Top": {
    defaultValue: "0px"
  },
  "Gallery.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Gallery.Cursor": {
    defaultValue: "pointer"
  },
  "Gallery.Box.Sizing": {
    defaultValue: "border-box"
  }
};
